<div class="mobile-filters guts-p-1-half">
  <div class="l_flexbar mobile-filters--buttons">
    <button
      *ngIf="showFilterReset"
      class="mobile-filters--buttons__button mobile-filters--buttons__reset"
      df-button
      data-dgat="search-view-v2-309"
      (click)="resetFilters.emit()"
    >
      {{ resetFiltersText }}
    </button>
    <button
      (click)="showFilters()"
      class="mobile-filters--buttons__button mobile-filters--buttons__filter"
      df-button
      dfButtonType="primary"
      data-dgat="search-view-v2-795"
    >
      {{ 'LearningSearch_ShowFilters' | translate }}
    </button>
  </div>
</div>
